import { BOOKING_OTHER_JOBS, type BookingOtherJobs } from '../functions/lib/customer-offer-data'
import { el } from './ui'
import './customer-offers.css'
// One booking-time choice, reused by New customer and Book them in. Neither answer is preselected.
export function otherJobsChoice(initial:BookingOtherJobs=null,onChange:(value:BookingOtherJobs)=>void=()=>{}) {
 let value=initial
 const node=el('section',{class:'other-jobs-choice','aria-label':'Other jobs'},el('h3',{},'Other jobs'),el('p',{},`Say to them: "${BOOKING_OTHER_JOBS}"`))
 const choices=el('div',{class:'other-jobs-choices'})
 const buttons=new Map<Exclude<BookingOtherJobs,null>,HTMLButtonElement>()
 for(const [pick,words] of [['fine',"That's fine"],['no','Rather not']] as const){
  const b=el('button',{type:'button',class:'link-button','aria-pressed':String(value===pick)},words) as HTMLButtonElement
  b.addEventListener('click',()=>{value=value===pick?null:pick;for(const [choice,button] of buttons)button.setAttribute('aria-pressed',String(value===choice));onChange(value)})
  buttons.set(pick,b);choices.append(b)
 }
 node.append(choices,el('p',{class:'muted other-jobs-skip'},'Skip this and they stay Not asked yet.'))
 return {node,value:()=>value,clear:()=>{value=null;for(const button of buttons.values())button.setAttribute('aria-pressed','false');onChange(value)}}
}
